import {
  FONT_SIZE_INCREMENT_VALUE_4,
  FONT_SIZE_INCREMENT_VALUE_8,
  MAX_FONT_SIZE
} from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import {
  TJackpotFontSizeOptions,
  TJackpotPool,
  TJackpotSize
} from 'interfaces/jackpot';

const DEFAULT_JACKPOT_SIZES = {
  main: {
    mobile: {
      name: 12,
      amount: 32
    },
    desktop: {
      name: 24,
      amount: 56
    }
  },
  pool: {
    mobile: {
      name: 12,
      amount: 18
    },
    desktop: {
      name: 12,
      amount: 18
    }
  }
};

const getJackpotDefaultFontSize = ({
  type,
  element
}: TJackpotFontSizeOptions): number => {
  const view = isMobile() ? 'mobile' : 'desktop';

  return DEFAULT_JACKPOT_SIZES[type][view][element];
};

const getJackpotElementLineHeight = (fontSize: number): number => {
  if (fontSize < MAX_FONT_SIZE) {
    return fontSize + FONT_SIZE_INCREMENT_VALUE_8;
  }

  return fontSize + FONT_SIZE_INCREMENT_VALUE_4;
};

export const getJackpotElementSize = ({
  type,
  element,
  value
}: TJackpotFontSizeOptions & { value?: string | number }): TJackpotSize => {
  const font = Number(value || getJackpotDefaultFontSize({ type, element }));

  return {
    font,
    line: getJackpotElementLineHeight(font)
  };
};

const reducer = (result: number, cur: TJackpotPool) => {
  return result + cur.CollectedAmount;
};

export const getTotalAmount = (poolList: TJackpotPool[]): number => {
  return poolList.reduce(reducer, 0);
};

export const JACKPOT_SPORTSBOOK_ID = 'jackpot-sportsbook';
export const JACKPOT_CALENDAR_ID = 'jackpot-sportsbook-calendar';
export const JACKPOT_MULTIVIEW_ID = 'jackpot-multiview';
export const jackpotModuleIds = [
  JACKPOT_SPORTSBOOK_ID,
  JACKPOT_CALENDAR_ID,
  JACKPOT_MULTIVIEW_ID
];
